/** Comprime o File via CompressionStream; se indisponível, devolve o original. */
export async function gzipFileForUpload(file: File): Promise<{
  file: File;
  originalBytes: number;
  uploadedBytes: number;
  gzipped: boolean;
}> {
  const originalBytes = file.size;
  if (file.name.endsWith('.gz')) {
    return { file, originalBytes, uploadedBytes: originalBytes, gzipped: true };
  }
  if (typeof CompressionStream === 'undefined') {
    return { file, originalBytes, uploadedBytes: originalBytes, gzipped: false };
  }

  const compressed = file.stream().pipeThrough(new CompressionStream('gzip'));
  const blob = await new Response(compressed).blob();
  const gzippedFile = new File([blob], `${file.name}.gz`, { type: 'application/gzip' });
  return {
    file: gzippedFile,
    originalBytes,
    uploadedBytes: gzippedFile.size,
    gzipped: true,
  };
}
